import request from "root/js/request";

export const getAnalyticsCrossMPBrands = async ({ cabinet_id, name, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/brands/",
    method: "get",
    params: {
      cabinet_id,
      name,
      ...rest,
    },
  });
  return response.data;
};
